






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class WordView extends Vue {
  public items: Common.WordEntry[] = new Array();
  public params: Common.WordEntryQuery = new Common.WordEntryQuery();
  public sortOptions: any = [{ value: 'key', text: '言語辞書キー' },{ value: 'defaultValue', text: '初期値' }];

  public onListViewCreated(){
    //リストビューのonExecとonDirectCommitを置き換えて上書き処理を実行する
    const temp :Components.ListView = this.$children[0] as Components.ListView;
    temp.onExec = async (item:any) =>{
      var query = new Common.WordEntryUpdateQuery();
      query.entry = item;      
      return this.$api.execute(query).then(obj => temp.onSubmit(obj));
    };

    temp.onDirectCommit = () =>{
      var query = new Common.WordEntryUpdateQuery();
      query.entry = temp.selected;      
      this.$api.execute(query).then(obj => {
      // 配列を更新して再選択する
      temp.$set(temp.items, temp.currentId, obj);
      temp.$nextTick(() => temp.listSelect(temp.currentId, false));
    });
    }
  }

}
